const LANGUAGE_ALIASES: Record<string, string> = {
	en: "en",
	"en-us": "en",
	"en-gb": "en",
	english: "en",
	"\u82f1\u8bed": "en",
	"\u82f1\u6587": "en",

	zh: "zh-CN",
	"zh-cn": "zh-CN",
	"zh-hans": "zh-CN",
	"zh-sg": "zh-CN",
	cn: "zh-CN",
	chinese: "zh-CN",
	"\u4e2d\u6587": "zh-CN",
	"\u7b80\u4f53\u4e2d\u6587": "zh-CN",
	"\u7c21\u9ad4\u4e2d\u6587": "zh-CN",
	"\u4e2d\u56fd\u8bed": "zh-CN",
	"\u4e2d\u56fd\u8a9e": "zh-CN",

	"zh-tw": "zh-TW",
	"zh-hant": "zh-TW",
	"zh-hant-tw": "zh-TW",
	"zh-hant-mo": "zh-TW",
	tw: "zh-TW",
	"\u7e41\u4f53\u4e2d\u6587": "zh-TW",
	"\u7e41\u9ad4\u4e2d\u6587": "zh-TW",

	"zh-hk": "zh-HK",
	"zh-hant-hk": "zh-HK",
	hk: "zh-HK",

	es: "es",
	"es-es": "es",
	"es-mx": "es",
	spanish: "es",
	espanol: "es",
	"espa\u00f1ol": "es",
	"\u897f\u73ed\u7259\u8bed": "es",
	"\u897f\u73ed\u7259\u8a9e": "es",

	ko: "ko",
	"ko-kr": "ko",
	kr: "ko",
	kor: "ko",
	korea: "ko",
	korean: "ko",
	"\u97e9\u8bed": "ko",
	"\u97d3\u8a9e": "ko",
	"\u97e9\u56fd\u8bed": "ko",
	"\u97d3\u56fd\u8a9e": "ko",
	"\ud55c\uad6d\uc5b4": "ko",

	ja: "ja",
	"ja-jp": "ja",
	jp: "ja",
	jpn: "ja",
	japan: "ja",
	japanese: "ja",
	"\u65e5\u8bed": "ja",
	"\u65e5\u8a9e": "ja",
	"\u65e5\u672c\u8bed": "ja",
	"\u65e5\u672c\u8a9e": "ja"
};

export function normalizeLang(input: any) {
	let value = input;

	if (value && typeof value === "object") {
		value = value.value ?? value._value ?? value.lang ?? value.key ?? value.locale ?? "";
	}

	const lang = String(value || "")
		.trim()
		.replace(/_/g, "-");
	const lower = lang.toLowerCase();

	if (!lower) return "";

	const aliased = LANGUAGE_ALIASES[lower];
	if (aliased) return aliased;

	// 浏览器常见复合标签：zh-Hant-TW / zh-Hans-CN / zh-TW-u-... 等
	if (lower.startsWith("zh-hant")) {
		if (lower.includes("hk") || lower.includes("mo")) return "zh-HK";
		return "zh-TW";
	}
	if (lower.startsWith("zh-hans") || lower.startsWith("zh-cn")) return "zh-CN";
	if (lower.startsWith("zh-tw")) return "zh-TW";
	if (lower.startsWith("zh-hk")) return "zh-HK";
	if (lower.startsWith("en")) return "en";
	if (lower.startsWith("es")) return "es";
	if (lower.startsWith("ko")) return "ko";
	if (lower.startsWith("ja")) return "ja";

	return lang;
}
